import React from 'react';
import c from 'classnames';

import ProjectCard from '../../../ProjectCard';
import { SearchAllProjectsHit } from '../../types';

const SearchAllProjectsResultsHit: React.FC<{ hit: SearchAllProjectsHit }> = ({ hit }) => {
  const classNames = c('SearchAllProjects__Results__Hit');

  return (
    <ProjectCard
      className={classNames}
      title={hit.title[0]}
      status={hit.project_status[0]}
      type={hit.project_type}
      image={hit.image_svg_url?.[0] || hit.image_style_uri?.[0]}
      link={hit.url[0]}
    />
  );
};

export default SearchAllProjectsResultsHit;
